module.exports = __webpack_public_path__ + "img/hair_back_male_short.274d8130.png";